import React from 'react';
import ClaimsSelectionFieldFullDate from '@rd-web-markets/shared/dist/company/kimble/ClaimsSelectionFieldFullDate';
const ClaimSelectionField = _ref => {
  let {
    toggleInclude,
    claims,
    toggleForm,
    includeSingleClaim,
    loading,
    setFromDate,
    setClaims
  } = _ref;
  return /*#__PURE__*/React.createElement(ClaimsSelectionFieldFullDate, {
    toggleInclude: toggleInclude,
    claims: claims,
    includeSingleClaim: includeSingleClaim,
    loading: loading,
    setFromDate: setFromDate,
    setClaims: setClaims
  });
};
export default ClaimSelectionField;